
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";
const namespace = "StudioModule";

@Component
export default class ColorBox extends Vue {
  @Prop() private color!: string;
  @Prop() private octave!: number;
  @Mutation('setSelectedColor', {namespace}) private setSelectedColor!: (value:string) => any;
  @Mutation('addSelectedColor', {namespace}) private addSelectedColor!: (value:string) => any;

  private handleClick(value: string){
    this.addSelectedColor(value);
    this.setSelectedColor(value);
  }
}

